module.exports = __webpack_public_path__ + "img/helper.280d4199.svg";